import React, {useState, useEffect, useMemo, useRef, useLayoutEffect} from 'react'
import { getStrength } from '../../../drugData/lookupDrugs';
import { medsCreateState, createMedsStep } from 'store/storeValtio';
import Select from 'components/common/Select';
import { isNullOrEmpty } from 'helpers/generalHelpers';
import { formType } from '../dropdownOptions';

export default function MedicationStrength({prevStep, nextStep}) {
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [errors, setErrors] = useState(null);
  //console.log('MedStrength', medsCreateState.strength);

  const strengths = useRef();
  const amt = useRef();
  const units = useRef();
  const type = useRef();

  const weightList = useMemo(() => [
    {label: 'Gram(s)', value: 'G'},
    {label: 'Milligram(s)', value: 'MG'},
    {label: 'Microgram(s)', value: 'MCG'},
  ],[]);

  const dosageTypeList = useMemo(() => [
    { 'label': 'Teaspoon', 'value': 'TSP' },
    { 'label': 'Tablespoon', 'value': 'TBSP' },
    { 'label': 'Milliliter', 'value': 'ML' },
    { 'label': 'Drop', 'value': 'DROP' },
  ],[]);

  useMemo(() => {
    //console.log('strength UE');
    let st = getStrength(medsCreateState.orangeId,medsCreateState.form);
    const strength = medsCreateState.strength;
    if (strength) {
      //var regexp = /^(\d+(?:\.\d+)?)([A-Za-z]+)?$/
      var regexp = /^(\d+(?:\.\d+)?)([A-Za-z]+)?(?:(?:\/)([A-Za-z]+))?$/
      const parts = strength.match(regexp);
      //console.log('parts', strength, parts);
      if (parts) {
        amt.current = parts[1];
        if (parts.length > 2) {
          units.current = parts[2];
          if (parts.length === 4 && parts[3]) {
            type.current = parts[3];
          }
        }
      }
    }

    st.push('Other');
    st.push('Not Indicated');
    st.push('Select Strength');
    strengths.current = st;
    const s = strengths.current.find(s => s === medsCreateState.strength);
    if (!s) {
      setSelectedIndex(strengths.current.length-1);
    }

    // for (let i = 0; i < strengths.current.length; ++i) {
    //   if (strengths.current[i] === medsCreateState.strength) {
    //     setSelectedIndex(i);
    //     break;
    //   }
    // }
    //console.log('useMemo end');
  },[]);

  function selectStrength(ix) {
    setSelectedIndex(ix);
    if (strengths.current[ix] === 'Select Strength') {
      let input = document.getElementById("strength"); 
      //console.log('weight', input.value);
      if (!input || isNullOrEmpty(input.value)) {
        setErrors("Please enter a weight value");
        return;
      }
      if (!units.current) {
        setErrors("Please enter a weight unit");
        return;
      }
      if (formType(medsCreateState.form) === 'V' && !type.current) {
        setErrors("Please enter a dosage type");
        return;
      }
      setErrors(null);
      var strength = input.value + units.current;
      if (type.current) strength += '/' + type.current;
      //console.log('strength', strength);
      medsCreateState.strength = strength;
      nextStep(createMedsStep.dosage);
    } else {
      const s = strengths.current[ix];
      //console.log('selectStrength', s);
      medsCreateState.strength = s;
      nextStep(createMedsStep.dosage);
    }
  }

  function changeUnits(u) {
    const newUnits = weightList[u].value;
    //console.log('changeUnits', u, newUnits);
    units.current = newUnits;
  }

  function changeType(t) {
    const newType = dosageTypeList[t].value;
    //console.log('changeUnits', t, newType);
    type.current = newType;
  }

  //console.log(`/${amt.current}/${units.current}/${type.current}/`, strengths.current);
  return (
    <>
      <div className='medBody'>
        What is the <b>strength</b> of your medication?
      </div>
      <div id='medList' className='medList'>
        {strengths.current && strengths.current.map((s,ix) => {
          const li = (ix === selectedIndex) ? 'py-1 bg-green-300' : 'py-1 bg-slate-300';
          return (
            <div
              key={ix} 
              className={'medCard ' + li} 
              onClick={()=>selectStrength(ix)} 
              id={s}>
              {s}
            </div>
            )
          })
        }
      </div>
      <div className='flex flex-col justify-center mt-4'>
        {errors && (
          <div
            className='bg-red-100 rounded-lg p-2 mx-10 mb-3 text-base text-red-700'
            role='alert'
          >
            {errors}
          </div>
        )}
        <div className='h-10 text-xl font-bold text-center'>
          Select the strength of your medication
        </div>
        <div className='flex justify-center px-4'>
          <input 
            className='w-3/12 text-xl mr-4'
            id='strength'
            name='strength'
            type='number'
            defaultValue={amt.current}
          />
          <Select
            className='w-6/12'
            options={weightList}
            placeholder='Choose units'
            onChange={changeUnits}
            defaultOption={units.current}
          />
        </div>
      </div>
      { formType(medsCreateState.form) === 'V' && 
        <div className='flex flex-col justify-center mt-4'>
          <div className='h-10 text-xl font-bold text-center'>
            Enter the per-unit doseage type
          </div>
          <div className='flex justify-center px-4'>
            <Select
              className='w-6/12'
              options={dosageTypeList}
              placeholder='Choose type'
              onChange={changeType}
              defaultOption={type.current}
            />
          </div>
        </div>
      }
    </>
    );
  }
